module.exports = __webpack_public_path__ + "static/media/heart-black.f704b242.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cart/heart-black.svg
// module id = 1944
// module chunks = 1